@if (conditionalWidgetData) {
<div class="cards col-12 h-100 m-0" style="max-width: 100%">
  <div class="divStyle pointer-events-none h-100">
    <div class="h-100 position-relative cursor-pointer pointer-events-none" (click)="goToLink()">
      <div
        class="title"
        [ngStyle]="contentStyle"
        [class.position-absolute-fill]="!pageConfiguration?.isUsingHtmlStructure"
      >
        @if (leftIcon) {
        <mat-icon
          class="mr-2 left-icon"
          [ngStyle]="leftIconSize"
          [svgIcon]="leftIcon"
        ></mat-icon>
        }
        <div [ngStyle]="textContentStyle">
          <div class="mr-auto" [innerHTML]="headerSubheaderTemplate | safeHtml"></div>
        </div>
        @if (rightIcon) {
        <mat-icon
          class="position-relative mr-2"
          [ngStyle]="rightIconSize"
          [svgIcon]="rightIcon"
        ></mat-icon>
        }
      </div>
    </div>
  </div>
</div>
}
